import * as validate from '../../shared/validate';
import PUBLIC_DOMAINS from '../constants/publicDomains';
import { BLOCKED_DOMAINS } from '../constants/publicEmails';

export const DOMAIN_BLOCKED_ERROR_MESSAGE = 'Domain not eligible.';
export const DOMAIN_INVALID_MESSAGE = 'Domain invalid.';

export const parseDomain = domainOrEmail => {
  // Handles either a domain or an email string and parses
  // out the domain portion `johnny.com`
  return domainOrEmail.split('@').reverse().shift().toLowerCase();
};

export const checkForDisallowedDomain = domain => {
  if (BLOCKED_DOMAINS.includes(domain)) {
    throw new Error(DOMAIN_BLOCKED_ERROR_MESSAGE);
  }
};

/**
 * Validates a domain string
 * @param domain the domain string
 * @returns true if domains string exists and is valid
 */
export const validateDomain = domain => {
  if (!domain || !validate.domain(domain)) {
    throw new Error(DOMAIN_INVALID_MESSAGE);
  }

  if (BLOCKED_DOMAINS.includes(domain)) {
    throw new Error(DOMAIN_BLOCKED_ERROR_MESSAGE);
  }
};

/**
 * Validates that a domain is a public domain
 * @param domain the domain string
 * @returns true if the domain is included in our list of public domains
 */
export const isPublicDomain = domain => {
  if (!validate.domain(domain)) {
    return false;
  }

  const publicDomains = PUBLIC_DOMAINS;

  return publicDomains.has(domain);
};
